import React, {Component} from 'react'

import style from './features.sass'

class Features extends Component {
  render() {
    return(
      <div>
        <section styleName='access'>
          <div className='landing-container' styleName='container'>
            <div styleName='column'>
              <h2>Access market Sentiment data for Coins and Stocks</h2>
              <ul>
                <li>One intuitive interface that connects you to different data vendors</li>
                <li>Supports Bitcoin, Ethereum, XRP and many more coins</li>
                <li>Build and test strategies seamlessly in English</li>
              </ul>
            </div>
            <div styleName='column'>
              <img styleName='links' src='/img/landing/home/access-img.png' alt=''/>
            </div>
          </div>
        </section>
        <section className='bg-white'>
          <div className='landing-container' styleName='container'>
            <div styleName='column-cloud'>
              <img styleName='cloud' src='/img/landing/home/data-img.png' alt=''/>
            </div>
            <div styleName='column'>
              <h2>Secure connection to your Broker account</h2>
              <ul>
                <li>Securely connect your broker account to Algoriz to automate your trading algorithms</li>
                <li>Build strategies with your broker data alone or in conjunction with our vendor&apos;s data</li>
                <li>Currently supports Interactive Brokers</li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default Features
